import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { ICONS } from 'Components/utils/icon/icons';
import * as pleUtils from 'Utils/ple-utils';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { useAppContext } from 'Context/ReactAppContext';
import { windowWrapper } from '@clubmed/utils';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { BE_GA_DEFAULT_PAYLOAD } from 'Views/booking/constants';
import { Button } from 'Components/frameworks/button/Button';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Text } from 'Components/frameworks/text/Text';
type Props = {
  className?: string;
  isQuickLogged?: boolean;
};
export const NotificationLoginToPle = ({ className, isQuickLogged }: Props) => {
  const track = useTracking();
  const appContext = useAppContext();
  const loginUrl = isQuickLogged
    ? pleUtils.buildStepupUrl({
        redirectUri: windowWrapper.getLocation(),
        locale: appContext.locale,
      })
    : pleUtils.buildSigninUrl({
        redirectUri: windowWrapper.getLocation(),
        locale: appContext.locale,
      });
  const bulletpoints = [
    t('booking.participants.connectToPLE.bulletpoint1'),
    t('booking.participants.connectToPLE.bulletpoint2'),
    t('booking.participants.connectToPLE.bulletpoint3'),
  ];
  return (
    <aside
      className={classnames('rounded-12 border-1 border-lightGrey bg-white', className)}
      data-testid="loggin-block"
    >
      <div className="flex flex-col sm:flex-row sm:flex-wrap">
        <div className="p-20 pb-0 sm:w-1/2 sm:pb-20 sm:pe-10">
          <div className="flex items-end gap-20 font-brand text-14 text-black">
            <Icon className="shrink-0 sm:mx-10" name={ICONS.ICON_45} width="2.5em" />
            <Text text={t('booking.participants.connectToPLE.message')} theme="none" />
          </div>
        </div>
        <div className="p-20 py-15 sm:w-1/2 sm:py-20 sm:ps-10">
          <ul>
            {bulletpoints.map((bulletpoint) =>
              bulletpoint ? (
                <li className="flex items-baseline gap-10 text-12" key={bulletpoint}>
                  <Icon
                    className="shrink-0 align-middle text-green"
                    name={ICONS.CHECK}
                    width="0.625rem"
                  />
                  {bulletpoint}
                </li>
              ) : null,
            )}
          </ul>
        </div>
        {isFeatureFlipped(appContext)('booking.displayFutureTravelCredit') && (
          <div className="mx-auto flex w-full flex-wrap p-20 pt-0 sm:flex-nowrap sm:py-20 sm:pt-0">
            <div className="flex items-center gap-20 font-brand text-14 text-sienna sm:w-1/2 sm:pe-10">
              <Icon className="shrink-0" name={ICONS.PROMO_CODE} width="2.5rem" />
              {t('booking.summary.futureTravelCredit.popinFtcTitle')}
            </div>
            <div className="ps-60 text-12 sm:w-1/2 sm:ps-10">
              {t('booking.summary.futureTravelCredit.signIn')}
            </div>
          </div>
        )}
      </div>
      <div className="border-t-1 border-lightGrey p-20 text-center">
        <Button
          className="mx-auto max-w-full"
          data-testid="loggin-button"
          isExternalLink
          onClick={() =>
            track({
              ...BE_GA_DEFAULT_PAYLOAD,
              actionGA: 'participant',
              labelGA: 'connectionParticipant',
            })
          }
          url={loginUrl}
        >
          {t('booking.participants.connectToPLE.buttonLabel')}
        </Button>
      </div>
    </aside>
  );
};
